@if (showInfoPanel()) {
    <div (click)="openQuickDepositPanel()">
        <div class="qb-info-panel" [class]="messageTypeClass" [innerHTML]="infoPanel.msg | safe: 'html'"></div>
    </div>
}
